import moment from 'moment';
import Constants from '../../../constants/Constants';

export const dateTimeDailyOrMonthlyRounding = (
  target,
  stateDateFrom,
  stateDateTo,
  newDate,
  startType,
  endType
) => {
  let newRange = {
    dateFrom: stateDateFrom,
    dateTo: stateDateTo,
  };

  switch (target) {
    case 'from':
      if (startType == 'month') {
        newDate.startOf('month');
      } else if (startType == 'date') {
        newDate.startOf('day');
      }

      if (newDate.isBefore(stateDateTo)) {
        newRange.dateFrom = newDate;
      } else {
        newRange.dateFrom = newDate;
        newDate = moment(newDate);
        newRange.dateTo =
          startType == 'month'
            ? newDate.add(1, 'months')
            : startType == 'date'
            ? newDate.add(1, 'days')
            : newDate.add(1, 'minutes');
      }
      break;
    case 'to':
      if (endType == 'month') {
        newDate.startOf('month');
      } else if (endType == 'date') {
        newDate.startOf('day');
      }

      if (newDate.isAfter(stateDateFrom)) {
        newRange.dateTo = newDate;
      } else {
        newRange.dateTo = newDate;
        newDate = moment(newDate);
        newRange.dateFrom =
          startType == 'month'
            ? newDate.subtract(1, 'months')
            : startType == 'date'
            ? newDate.subtract(1, 'days')
            : newDate.subtract(1, 'minutes');
      }
      break;
  }

  newRange.dateFrom = moment(newRange.dateFrom).second(0);
  newRange.dateTo = moment(newRange.dateTo).second(0);
  return newRange;
};

export const dateTimeRangeRounding = (newStartValue, newEndValue, options) => {
  //we do the rounding here: we extend the range to the nearest multiple of the minimum duration
  let newStart = moment.utc(newStartValue);
  let newEnd = moment.utc(newEndValue);
  let timeDiff = newEnd.diff(newStart);

  let option = options.find(
    (range) =>
      (!range.start || moment.duration(range.start) <= timeDiff) &&
      (!range.end || moment.duration(range.end) > timeDiff)
  );

  //if no rounding required just set the extra parameter
  if (!option.granularity) {
    return {
      dateFrom: newStart,
      dateTo: newEnd,
      optionValue: option.value,
      reductionSpanHumanString: null,
    };
  }

  let granularity = moment.duration(option.granularity);
  let granularityms = granularity.asMilliseconds();

  let nearestDateTimeToNewStart = moment.utc(
    newStart.clone().startOf('day').isSame(newStart)
      ? newStart.valueOf()
      : newStart.valueOf() - (newStart.valueOf() % granularityms)
  );

  let remainder = newEnd.valueOf() % granularityms;
  let nearestDateTimeToNewEnd = moment.utc(
    newEnd.valueOf() - remainder + (remainder != 0 ? granularityms : 0)
  );

  if (granularityms >= 86400000) {
    nearestDateTimeToNewStart.startOf('day');
    nearestDateTimeToNewEnd = newEnd.startOf('day');
  }

  let reductionSpanHumanString = granularity.locale('en').humanize();

  return {
    dateFrom: nearestDateTimeToNewStart,
    dateTo: nearestDateTimeToNewEnd,
    optionValue: option.value,
    reductionSpanHumanString,
  };
};

export const convertDateTime = (
  dateFrom,
  dateTo,
  startTypeToConvertTo,
  endTypeToConvertTo,
  selectionType
) => {
  if (selectionType && selectionType == 'single') {
    dateTo = endTypeToConvertTo == 'month' ? dateFrom.add(1, 'months') : dateFrom.add(1, 'days');
  } else if (startTypeToConvertTo == 'month' && endTypeToConvertTo == 'month') {
    let startOfDateFrom = moment(dateFrom).startOf('month');
    let startOfDateTo = moment(dateTo).startOf('month');

    if (startOfDateFrom.isSame(startOfDateTo)) {
      dateTo.add(1, 'months');
    }
  }

  let newRange = dateTimeDailyOrMonthlyRounding(
    'from',
    dateFrom,
    dateTo,
    dateFrom,
    startTypeToConvertTo,
    endTypeToConvertTo
  );

  newRange = dateTimeDailyOrMonthlyRounding(
    'to',
    newRange.dateFrom,
    newRange.dateTo,
    dateTo,
    startTypeToConvertTo,
    endTypeToConvertTo
  );

  return newRange;
};

export const copyTime = (
  sourceDateTimeFrom,
  sourceDateTimeTo,
  targetDateTimeFrom,
  targetDateTimeTo
) => {
  let dateTimeFrom = moment.utc(sourceDateTimeFrom);

  targetDateTimeFrom.set({
    hour: dateTimeFrom.get('hour'),
    minute: dateTimeFrom.get('minute'),
    second: dateTimeFrom.get('second'),
  });

  let dateTimeTo = moment.utc(sourceDateTimeTo);

  targetDateTimeTo.set({
    hour: dateTimeTo.get('hour'),
    minute: dateTimeTo.get('minute'),
    second: dateTimeTo.get('second'),
  });

  let newRange = {
    dateFrom: targetDateTimeFrom,
    dateTo: targetDateTimeTo,
  };

  return newRange;
};

export const checkDateTimeCorrectness = (dateFrom, dateTo) => {
  if (moment(dateFrom).isAfter(dateTo)) {
    return Constants.DATEFROM_AFTER_DATETO_ERROR_MESSAGE;
  }

  if (moment(dateTo).isBefore(dateFrom)) {
    return Constants.DATETO_BEFORE_DATEFROM_ERROR_MESSAGE;
  }
  return null;
};
